
<section v-if="card.collectionCardId" class="card-profile-collection-investment">
  <h4 class="secondary-font">
    Investment
  </h4>

  <div class="stats">
    <stat-item
      label="Total Investment"
      :value="$filters.currency(totalInvestment)"
    />

    <stat-item
      v-if="card.quantity > 1"
      label="Cost Per Card"
      :value="$filters.currency(card.investment)"
    />

    <stat-item
      v-if="typeof card.priceMovement === 'number'"
      label="Daily $ Change"
      :value="`${card.priceMovement > 0 ? '+' : ''}${$filters.currency(card.priceMovement)}`"
      :success="card.priceMovement > 0"
      :error="card.priceMovement < 0"
    />

    <stat-item
      v-if="card.quantity > 1 && card.priceSold"
      label="Average Sold Price"
      :value="$filters.currency(card.priceSold)"
    />

    <stat-item
      v-if="card.sold && typeof card.priceSold === 'number' && typeof card.quantitySold === 'number'"
      :label="`${card.quantity > 1 ? 'Total ' : ''}Sold Price`"
      :value="$filters.currency(card.priceSold * card.quantitySold)"
    />

    <stat-item
      v-if="typeof card.profit === 'number'"
      :label="profitLabel"
      :value="`${card.profit > 0 ? '+' : ''}${$filters.currency(card.profit)}`"
      :success="card.profit > 0"
      :error="card.profit < 0"
    />

    <stat-item
      v-if="typeof roi === 'number'"
      :label="roiLabel"
      :value="`${roi > 0 ? '+' : ''}${$filters.percentage(roi)}`"
      :success="roi > 0"
      :error="roi < 0"
    />

    <stat-item
      v-if="card.ownsPercentage && typeof card.ownershipPercentage === 'number'"
      :label="`${card.quantity > 1 ? 'Total ' : ''}Ownership %`"
      :value="$filters.percentage(card.ownershipPercentage / 100)"
    />
  </div>
</section>
